export default "__VITE_ASSET__Can7e8gu__"